import { z } from 'zod';
import { auditFieldsSchema, idSchema, paginated, paginationQuerySchema } from './common.js';
/**
 * Chave de API para o site amaipark.com (e futuros integradores) consumirem a
 * plataforma. Guardamos apenas o hash; o segredo aparece uma única vez, na
 * criação. `prefix` identifica a chave na listagem.
 */
export const API_KEY_SCOPES = [
    'public:leads',
    'public:day-use',
    'public:content',
    'public:availability',
];
export const apiKeyScopeSchema = z.enum(API_KEY_SCOPES);
export const API_KEY_SCOPE_LABELS = {
    'public:leads': 'Receber leads do site',
    'public:day-use': 'Vender Day Use',
    'public:content': 'Ler conteúdo (CMS)',
    'public:availability': 'Consultar disponibilidade',
};
export const apiKeySchema = auditFieldsSchema.extend({
    id: idSchema,
    companyId: idSchema,
    name: z.string(),
    prefix: z.string(),
    scopes: z.array(apiKeyScopeSchema),
    isActive: z.boolean(),
    lastUsedAt: z.string().nullable(),
    expiresAt: z.string().nullable(),
    revokedAt: z.string().nullable(),
});
export const apiKeyInputSchema = z.object({
    name: z.string().trim().min(2, 'Dê um nome à chave').max(120),
    scopes: z.array(apiKeyScopeSchema).min(1, 'Selecione ao menos um escopo'),
    expiresAt: z.string().optional().nullable(),
});
/** Resposta da criação — única vez em que `secret` trafega. */
export const apiKeyCreatedSchema = z.object({
    apiKey: apiKeySchema,
    secret: z.string(),
});
export const apiKeyListQuerySchema = paginationQuerySchema;
export const apiKeyListResponseSchema = paginated(apiKeySchema);
//# sourceMappingURL=api-key.js.map